module.exports = __webpack_public_path__ + "static/2-e68fd8fef749796dfda73e4d20bf07ab.png";